export function fromSimpleTaxonomy (taxonomyObjects) {
  return taxonomyObjects ? taxonomyObjects.map(i => i.name).join(', ') : ''
}

export function fromSimpleSingleTaxonomy (taxonomyObject) {
  return taxonomyObject ? taxonomyObject.name : ''
}
